module.exports = __webpack_public_path__ + "static/img/b2c_logo.ca02269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/b2c_logo.png
// module id = uS1r
// module chunks = 1